<template>
  <div class="bg-black my-8" style="height: .1rem">
  </div>
</template>

<script>
export default {
  name: 'Divider'
}
</script>
